import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import theme from "../../theme";
import "./chartStyles.css";
import moment from "moment";

const CustomLineChart = ({ data, title, caption }) => {
  const bgColor = useColorModeValue('chart-box', 'chart-box-dark');
  const chartColors = Object.values(theme.colors.lineChartColors);
  const textColor = useColorModeValue("chart-title", "chart-title-dark");

  // Parse the API data
  const parseData = (apiData) => {
    const chartData = [];

    // Iterate over each key in the apiData (e.g., "CurrentYear", "PreviousYear")
    Object.keys(apiData).forEach((key) => {
      const dataSeries = apiData[key];

      // Only process if the dataSeries is an array
      if (Array.isArray(dataSeries)) {
        dataSeries.forEach((item) => {
          const dateFormatted = moment(item.dateTime).format('MM-DD');

          // Find or create the entry for this date
          let entry = chartData.find((d) => d.date === dateFormatted);
          if (!entry) {
            entry = { date: dateFormatted };
            chartData.push(entry);
          }

          // Assign the value to the appropriate key (line)
          entry[key] = item.value;
        });
      }
    });

    return chartData;
  };

  const chartData = parseData(data);
  const isRevenueData = Object.keys(data).some((key) => key === "CurrentYear")

  return (
    <Box className={`${bgColor} chart-hover-effect`}>
      <Text mb={3} fontSize="xl" fontWeight="600" color={textColor}>
        {title}
      </Text>
      <Text>
        {caption}
      </Text>
      <Box className="divider"></Box>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          { isRevenueData ? <YAxis
            tickFormatter={(value) => (value / 1000000).toFixed(2)}
            label={{ value: 'Production (Million)', angle: -90, position: 'insideLeft', dy:70}}
          /> : <YAxis
            domain={[0, 100]}
            label={{ value: 'Health Score', angle: -90, position: 'insideLeft', dy:50 }}
          />}
          <Tooltip
            labelFormatter={(label) => {
              return (
                <span className={'tooltip-title'} >
                  {label}
                </span>
              );
            }}
          />
          <Legend />
          {Object.keys(data).map((key, index) => (
            <Line
              key={index}
              type="monotone"
              dataKey={key}
              stroke={chartColors[index % chartColors.length]}
              dot={false}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default CustomLineChart;
